<template lang="pug">
v-dialog(
  v-model="popupDialog"
  transition="dialog-bottom-transition"
  width="900"
  )
  v-card
    v-toolbar(dense flat color="accent white--text")
      v-btn(icon @click.native="popupDialog = false" dark)
        v-icon close
      v-fade-transition(mode="out-in")
        v-toolbar-title Quick Link Versions
      v-spacer
    v-container
        v-data-table.versionList.responsiveTable(
            :headers="headers"
            :items="versions"
            :pagination.sync="pagination"
            class="elevation-1")
            <template slot="items" slot-scope="props">
                td(
                    class="text-xs-left"
                    data-title="Version"
                ) {{ props.item.version }}
                td(
                    class="text-xs-left"
                    data-title="Title"
                )
                  <v-tooltip top>
                    v-clamp(
                      autoresize
                      :max-lines="lineNumber"
                      slot="activator"
                    ) {{ props.item.title }}
                    <span>{{ props.item.title }}</span>
                  </v-tooltip>
                <td class="text-xs-left" data-title="Icon">
                    img(
                        :src="props.item.icon"
                    ).versionImageIcon
                </td>
                td(
                    class="text-xs-left"
                    style="width:250px;word-break:break-all;"
                    data-title="Url"
                )
                  a(@click="getLink(props.item)" target="_blank") {{ props.item.url }}
                td(
                    class="text-xs-left"
                     data-title="Status"
                ) {{ props.item.hidden ? "Disabled" : "Active" }}
                td(
                    class="text-xs-left"
                     data-title="UpdateTime"
                ) {{ props.item.updated_at | dateformat('YYYY-MM-DD HH:mm:ss') }}
                td(
                    class="text-xs-left"
                     data-title="UpdateBy"
                ) complispace.admin
                <td>
                    v-btn(
                    color="info"
                    :disabled="props.item.version == currentVersion.version"
                    @click="RevertVersion(props.item)"
                    ) Revert
                </td>
            </template>
</template>

<script>
import { mapState } from 'vuex';
import Base from '@/components/views/Base';
import { quicklink, blobs } from '@/api';
import VClamp from 'vue-clamp';

function sortVersion(a, b) {
    return a.version - b.version;
}

export default {
    name: 'VersionQuickLinkModuleDialog',
    extends: Base,
    components: {
        VClamp
    },

    props: {
        showDialog: { type: Boolean, default: false },
        list: { type: Array, default: () => { return []; } }
    },

    data() {
        return {
            popupDialog: false,
            versions: [],
            headers: [
                { text: 'Version', value: 'version', },
                { text: 'Title', value: 'title', },
                { text: 'Icon', value: 'icon' },
                { text: 'Url', value: 'url' },
                { text: 'Status', value: 'status' },
                { text: 'UpdateTime', value: 'update' },
                { text: 'UpdateBy', value: 'updateUser' },
                { text: '', value: '' },
            ],
            pagination: {
                descending: true,
                sortBy: 'version',
                rowsPerPage: 10
            },
            currentVersion: null,
            lineNumber: this.$store.state.appearance.characterLimitLine
        };
    },

    computed: {
        ...mapState({
            subdomain: state => state.session.subdomain
        }),
    },

    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        }
    },

    methods: {
        async LoadVersion(editLink) {
            const versionsResponse = await quicklink.getVersions(editLink.id, this.subdomain);
            const allVersions = versionsResponse.data.sort(sortVersion);
            this.currentVersion = allVersions[allVersions.length - 1];
            this.versions = allVersions;
        },

        async RevertVersion(versionItem) {
            const link = {
                id: this.currentVersion.id,
                version: this.currentVersion.version + 1,
                icon: versionItem.icon,
                url: versionItem.url,
                title: versionItem.title,
                description: versionItem.description,
                tags: versionItem.tags,
                organisation: versionItem.organisation,
                hidden: versionItem.hidden,
                priority: versionItem.priority,
                created_at: this.currentVersion.created_at,
                updated_at: new Date()
            };
            try {
                await quicklink.createVersion(link, this.subdomain);
                this.$emit('submit-add');
                this.showSuccessAlert('Revert version successfully');
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                this.popupDialog = false;
            }
        },

        showFile(blob, fileName) {
            // Source: https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = data;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                // For Firefox it is necessary to delay revoking the ObjectURL
                document.body.removeChild(link);
                window.URL.revokeObjectURL(data);
            }, 100);
        },
        getLink(item) {
            if (item.tags[0] === 'file') {
                let id = item.url.split('/');
                id = id[id.length - 1];
                blobs.getLinks(id, this.subdomain).then((result) => {
                    // FIXME: Workaround for our server not sending
                    // Content-Disposition. Load balancer issue?
                    const contentType = result.headers['content-type'];
                    let fileName = result.headers['content-disposition'];
                    fileName = fileName.substring(fileName.indexOf('=') + 1);
                    fileName = fileName.substring(1, fileName.length - 1);
                    const blob = new Blob([result.data],
                        { type: contentType });
                    this.showFile(blob, fileName);
                });
            } else {
                window.open(item.url, '_blank');
            }
        },
    }
};
</script>

<style scoped>
.versionImageIcon{
  width: 30px;
  height: 30px;
}
.versionList .v-datatable  th,.versionList .v-datatable td{
    padding:5px 10px!important;
}

@media (max-width:768px){
    .responsiveTable thead{
        display:none;
    }
    .responsiveTable tbody tr{
        display:block;
        margin-bottom:15px;
    }
    .responsiveTable tbody td,.responsiveTable tbody th{
        display:flex;
        align-items:center;
        height:auto!important;
        width:auto!important;
    }
    .responsiveTable tbody td:before,.responsiveTable tbody th:before{
        display:block;
        content:attr(data-title);
        flex:0 0 110px;
        padding:10px;
        padding-right:15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/content/VersionQuickLinkModuleDialog.vue